<template>
  <div>
    <div class="flex platform_box">
      <div class="platform" :class="contentTbas == index ? 'platformP' : ''" v-for="(items, index) in list" :key="items.uuid" @mouseenter="getContentList(index)">
        <div class="flex swipers_home2">
          <div class="swipers_home_center" >
            <img :src="require(`../../assets/home/${items.code}.png`)" alt="" />
            <p :class="contentTbas == index ? 'swiperP' : ''">{{ items.name }}</p>
            <p v-if="contentTbas == index" :class="contentTbas == index ? 'animate__animated animate__pulse' : ''" style="width: 100%;height:3px;background-color: #099;margin-top: 23px;"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "swiper",
  components: {},
  props: {
    list: Array,
    default: () => []
  },
  data() {
    return {
      dataHref: "",
      // 平台是核心
      contentTbas: "0",
      contentTbasIndex: "0",
      conShow: false,
      setIn: null, // 定时器
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init()
    })
  },
  methods: {
    getContentList(i) {
      this.contentTbas = i;
      this.$emit('tabsIndex', i)
      console.log(i);
    }
  },
};
</script>

<style scoped lang="less">
.mc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.swiper-container {
  width: 100%;
  height: auto;
  padding: 0 0 100px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 200px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition-property: all;
}

.platform_box {
  width: 800px;
  align-items: center;
  justify-content: space-between;

  .platform {
    cursor: pointer;
    // padding-bottom: 23px;
  }
  // .platformP {
  //   border-bottom: 3px solid #099;
  // }
}

.park_car_img {
  width: 100%;
  height: 200px;
  background: #009999;
  border-radius: 10px;
}

.park_swipers {
  .park_swipers_img {
    width: 215px;
    height: 100px;
    border-radius: 10px;

    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-size: 14px;
    color: #777;
    margin-top: 10px;
  }
}

.swiper-slide {
  height: 100%;
  border-radius: 10px;
  background: none;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 250px;
  background: #ffffffb8;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
  top: 32%;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 250px;
  background: #ffffffb8;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
  top: 32%;
}

.swipers_home2 {
  font-size: 16px;
  font-weight: 400;
  color: #1D1D1D;
  align-items: center;
  justify-content: space-between;

  .swipers_home_center {
    img {
      width: 90px;
    }

    .swiperP {
      color: #009999;
    }
  }
}

.content_title {
  font-size: 16px;
  margin: 25px 0 20px;
}

.content_content {
  width: 620px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: lighter;
  color: #808080;
  line-height: 27px;
  // height: 83px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 38px;
}

.conIcon {
  justify-content: center;

  .icons {
    background: #1680f5;
  }

  i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkSwiper/homeSwiper.vue